function invariant(condition: any, message: string): asserts condition {
  if (!condition) throw new Error(message);
}

invariant(process.env.CARVANA_APP_ACCOUNT_API_URL, 'CARVANA_APP_ACCOUNT_API_URL must be set');
invariant(process.env.CARVANA_APP_CONSENT_API_URL, 'CARVANA_APP_CONSENT_API_URL must be set');
invariant(process.env.CARVANA_APP_ENVIRONMENT, 'CARVANA_APP_ENVIRONMENT must be set');
invariant(
  process.env.CARVANA_APP_REFERRAL_ELIGIBILITY_API_URL,
  'CARVANA_APP_REFERRAL_ELIGIBILITY_API_URL must be set'
);
invariant(
  process.env.CARVANA_APP_USER_PROFILE_API_URL,
  'CARVANA_APP_USER_PROFILE_API_URL must be set'
);

export const accountApiUrl = process.env.CARVANA_APP_ACCOUNT_API_URL;

export const consentApiUrl = process.env.CARVANA_APP_CONSENT_API_URL;

export const environment = process.env.CARVANA_APP_ENVIRONMENT;

export const isLocalEnvironment = process.env.CARVANA_APP_IS_LOCAL_ENVIRONMENT === 'true';

export const referralEligibilityApiUrl = process.env.CARVANA_APP_REFERRAL_ELIGIBILITY_API_URL;

export const userProfileApiUrl = process.env.CARVANA_APP_USER_PROFILE_API_URL;
